import { UsersService } from './../../services/UsersService';
import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { RoundAndClinicService } from 'src/app/services/RoundAndClinicService';
import { RoundAndClinicModel } from 'src/app/models/RoundAndClinicModel';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { UsersModel } from 'src/app/models/UsersModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-round-and-clinics-viwe',
  templateUrl: './round-and-clinics-viwe.component.html',
  styleUrls: ['./round-and-clinics-viwe.component.css'],
})
export class RoundAndClinicsViweComponent implements OnInit {
  patientcode = '';
  note = '';
  Laboratory = '';
  Toxicity = '';
  Nutrition = '';
  Response = '';
  DrugInteractions = '';
  Hypersensitive = '';
  PatientEducation = '';
  notetype = '';
  date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  extra = '';
  userid = '';
  compcode = '';

  roundandclinic: RoundAndClinicModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public RoundAndClinicService: RoundAndClinicService,
    public RoundsAndClinics: RoundAndClinicModel,
    public users: UsersModel,
    public UsersService: UsersService,
    public dialogref: MatDialog,
    public storage: LocalStorageService,
    public RoundSelectedData: RoundAndClinicModel,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.retriveRoundAndClinicsTop();
  }

  retriveRoundAndClinicsTop() {
    this.roundandclinic = [];
    this.RoundAndClinicService.Getroundandclinic(
      this.storage.retrieve('stgPatientCode')
    ).subscribe((data: RoundAndClinicModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.roundandclinic[i] = data[i];
        this.roundandclinic[i].notetype = data[i].notetype;
        this.roundandclinic[i].note = data[i].note;
        this.roundandclinic[i].date = formatDate(
          data[i].date,
          'yyyy-MM-dd',
          'en'
        );
        this.roundandclinic[i].extra = data[i].extra;
      }
    });
  }

  getColorClass(notetybe: string) {
    if (notetybe == 'Hypersensitive') return 'red-bg';
    return '';
  }


}
